define('SageDotCom/Components/Collections/CampaignCarouselPane',[
    'jquery',
    'eventManager',
    'score_bootstrap/Components/CarouselPicturePane'
],
    function ($, eventManager, pictureCarouselBase) {
        function CampaignCarouselPane(scope, selectActionMessages) {

            pictureCarouselBase.call(this, scope, selectActionMessages);

        }

        CampaignCarouselPane.prototype = Object.create(pictureCarouselBase.prototype);

        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new CampaignCarouselPane(args.scope, args.selectActionMessages || []);
        };
    });
